import Vue from 'vue'
import App from './App.vue'
import VueMq from 'vue-mq'
 
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    s: 450,
    m: 1250,
    l: Infinity,
  },
  defaultBreakpoint: 'm' // customize this for SSR
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
